import { useTranslation } from 'react-i18next'
import { StatusChip } from '../StatusChip/StatusChip'
import type { StatusTone } from '../StatusChip/types'
import { cx } from '../utils/cx'
import type { RequestCardProps, RequestStatus } from './types'
import './RequestCard.css'

const TONE: Record<RequestStatus, StatusTone> = { received: 'info', progress: 'warning', resolved: 'success' }

/** Tarjeta de petición (DESIGN.md §4): título, fecha, chip de estado y última actualización. */
export function RequestCard({ title, date, status = 'received', updated, onClick, className }: RequestCardProps) {
  const { t } = useTranslation()
  const content = (
    <>
      <div className="hp-request__head">
        <span className="hp-request__title">{title}</span>
        <StatusChip tone={TONE[status]}>{t(`v2.ds.requestCard.${status}`)}</StatusChip>
      </div>
      <div className="hp-request__date tnum">{date}</div>
      {updated && <div className="hp-request__updated tnum">{t('v2.ds.requestCard.ultimaActualizacion', { when: updated })}</div>}
    </>
  )
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cx('hp-request hp-request--clickable', className)}>
        {content}
      </button>
    )
  }
  return <div className={cx('hp-request', className)}>{content}</div>
}
